import http from '@/http'

export default class EstadoSelecaoService {
 
    getEstadosSelecao() {
		console.log('getAreas ...');
		return http.get('/selecao/estados-selecoes').then(res => res.data);
    }

}
